<template>
  <TsCard no-border no-shadow append-class="overflow-visible">
    <TsTypography align="center" as="h2">{{
      useTranslation('ourBranches', 'Onze vestigingen')
    }}</TsTypography>
    <TsTypography align="center" append-class="mb-2.5">
      {{
        useTranslation(
          'enhanceYourExperiencewithFasterOrders',
          'Verbeter uw Toolstation-ervaring met snellere en nauwkeurige bestellingen voorraad: update nu uw favoriete filiaal'
        )
      }}!
    </TsTypography>

    <div class="max-w-lg mx-auto">
      <TsAutoCompleteLocality
        v-model:input="branchStore.localitySearchInput"
        v-model:selected="branchStore.selectedLocality"
        data-testid="locality-autocomplete"
        :placeholder="enterPostalCodeOrCityPlaceholderText"
        search-label="description"
        :suggestions="branchStore.autoCompleteSuggestions"
        :loading="branchStore.isProcessingLocalitySearch"
        :input-class="'rounded-lg'"
        :input-variant="
          branchStore.noSuggestionsAvailable || branchStore.noNearestBranchAvailable
            ? 'danger'
            : 'default'
        "
        @input="branchStore.delayedAutoCompleteSearch([appRegion.toLowerCase()])"
        @select="handleSuggestionSelect"
        @enter="handleEnterClick"
        @clear="branchStore.autoCompleteSuggestions = []"
      />
      <TsTypography
        v-if="branchStore.noSuggestionsAvailable"
        :data-testid="props.dataTestid + '-error-message'"
        append-class="text-danger ml-4 mt-0.5 text-xs"
      >
        {{ useTranslation('addressNotFound', 'No such locality or address found.') }}
      </TsTypography>
    </div>
  </TsCard>
</template>

<script setup lang="ts">
import { useTranslation } from '~/composables/useTranslation';

const { $customClientErrorHandler } = useNuxtApp();

const TsCard = defineAsyncComponent(() => import('~/components/organisms/TsCard.vue'));

const TsAutoCompleteLocality = defineAsyncComponent(
  () => import('~/components/organisms/TsAutoCompleteLocality.vue')
);

const props = defineProps<{
  dataTestid?: string;
}>();

const branchStore = useBranchStore();
const localePath = useLocalePath();
const enterPostalCodeOrCityPlaceholderText = useTranslation(
  'enterPostalCodeOrCityName',
  'Enter postal code or city name'
);
const appRegion = useRuntimeConfig().public.appRegion;

async function handleEnterClick() {
  if (!branchStore.formattedSearchQuery.length) return;

  await navigateTo({
    path: localePath('/branches'),
    query: {
      postal_code: branchStore.localitySearchInput.trim(),
    },
  });
}

async function handleSuggestionSelect() {
  if (!branchStore.selectedLocality || !branchStore.selectedLocality.description) return;

  if (
    !(branchStore.selectedLocality as any).location.lat ||
    !(branchStore.selectedLocality as any).location.lng
  ) {
    const error = `about-us page our branches nearby search failed on click of autocomplete suggestions; latitude or longitude not found`;
    const errorMeta = {
      locality: branchStore.selectedLocality,
      description: branchStore.selectedLocality.description,
      branchError: true,
    };

    $customClientErrorHandler(
      error,
      'high',
      'TsBranchLocatorForm Component Error - trying to handle suggestions on select using handleSuggestionSelect()',
      errorMeta
    );
    return;
  }

  await navigateTo({
    path: localePath('/branches'),
    query: {
      q: branchStore.selectedLocality.description,
      lat: parseFloat((branchStore.selectedLocality as any).location.lat).toFixed(2),
      long: parseFloat((branchStore.selectedLocality as any).location.lng).toFixed(2),
    },
  });
}

onMounted(() => {
  branchStore.autoCompleteDropdownVisible = false;
  branchStore.resetStatuses();
});
</script>
